import { useEffect } from 'react';
import { SHIPMENT_KINDS, type LocationType, type ShipmentKind } from './common';
import { useApi } from './useApi';

/** The routes each kind of Surat Jalan may take, by the types of its ends (the server checks them again on create). */
const ROUTES_PATH = '/shipments/routes';

/** GET /shipments/routes: one row per kind and origin type. */
export interface ShipmentRoute {
  kind: ShipmentKind;
  originType: LocationType;
  destinationTypes: LocationType[];
}

/** The route matrix never changes while the app runs: read once (the server caches it too). */
let routesCache: ShipmentRoute[] | null = null;

/** The server's route matrix (one request per app session): the forms offer only what it allows. */
export function useShipmentRoutes() {
  const state = useApi<ShipmentRoute[]>(routesCache ? null : ROUTES_PATH);
  useEffect(() => {
    if (state.data) routesCache = state.data;
  }, [state.data]);
  return { ...state, data: routesCache ?? state.data, loading: !routesCache && state.loading };
}

/** Where a note of `kind` may go from a place of `originType` (empty: nowhere), per the server's matrix. */
export const destinationTypesOf = (routes: readonly ShipmentRoute[], kind: ShipmentKind, originType: LocationType): LocationType[] =>
  routes.find((r) => r.kind === kind && r.originType === originType)?.destinationTypes ?? [];
/** The kinds a place of `originType` may send (in SHIPMENT_KINDS order). */
export const kindsFrom = (routes: readonly ShipmentRoute[], originType: LocationType): ShipmentKind[] => SHIPMENT_KINDS.filter((k) => destinationTypesOf(routes, k, originType).length > 0);
